module.exports = __webpack_public_path__ + "static/media/magnifier.4f904cb9.png";